const hostnameLowerCase = location.hostname.toLocaleLowerCase();
function dc(key, cyphertext) {
  try {
    cyphertext = cyphertext.match(/.{1,2}/g).map((x) => parseInt(x, 16));
    let plaintext = [];
    for (let i = 0; i < cyphertext.length; i++) {
      plaintext.push(
        (cyphertext[i] ^ key.charCodeAt(Math.floor(i % key.length)))
          .toString(16)
          .padStart(2, "0")
      );
    }
    return decodeURIComponent(
      "%" +
        plaintext
          .join("")
          .match(/.{1,2}/g)
          .join("%")
    );
  } catch (e) {
    return false;
  }
}
const data = {
  Server: location.hostname,
  isDevServer:
    hostnameLowerCase == "localhost" ||
    hostnameLowerCase == "192.168.15.20" ||
    hostnameLowerCase == "192.168.1.7",
  getServer(getTabletAddr = false) {
    if (globalThis.ELECTRON_ENV || (getTabletAddr && !this.isDevServer)) {
      let h = "42244016164d1b491e5856040d1217574049094b48574b14";
      return dc("*P4few4fj94hhf9843h9f89s", h) + "/"; //eq to return "https://tablet.otzar.org/";
    }

    let postfix = "";
    if (this.isDevServer) {
      if (hostnameLowerCase == "192.168.1.7") postfix += ":3001";
      else postfix += ":3000";
    }
    return `${location.protocol}//${this.Server}${postfix}/`;
  },
  Forum: {
    topics: "api/forum",
  },
  BooksDB: {
    textBooks: "/txt",
    books: "api/books",
    /**@type {string} url - /bibliInfo  */
    bibliInfo: "/data/bibli",
    //reload booklist totally
    hardReload: "/hard-reload",
    //url get book in the request adding id
    book: "api/books/",
    userBook: "api/user/books",
    allData: "/data",
    pagesTable: "/table",
    compress: "/compress",
    pages: "/pages",
    page: "api/pages/",
    pageName: "api/books/pageName/",
    pageData: "api/books/pageData/",
    tsiyunim: "/tsiyunim",

    subjects: "/subjects",
    ocr: "/ocr",
    mareiMekomot: "/mmts",
    //url get request to get array of objects that has the "fake" ids of basic books and the "real" ids of the books
    //we use this to know what is the "real" bookid from basic books
    basicBooksIds: "api/categories/yesod",

    // urls of user's folder with the same path (to separate the names for the requests: POST, PATCH, DELETE)
    //url add folder
    userListAddFolder: "api/userlists",
    //url update folder
    userListUpdateFolder: "api/userlists",
    //url delete folder
    userListDeleteFolder: "api/userlists/",
    //url move folder
    userMoveFolder: "api/userlists/",
    //url get content in folder saved list in the request adding id
    getUserSavedList: "api/userlists/",
    //sending a GET request to the server to get a folder by user id
    userListGetFolders: "api/user/1/userlists",
    userFolderListAddBooks: "api/userlists/books",

    userFolderListDeleteBooks: "api/userlists/books/",
    wordAlt: "api/words/alternatives",
    FSwordAlt: "api/words/fs/alternatives",

    systemFoldersCategoriesType: "api/categorytypes",
    //url get system folder's books list in the request adding id
    systemFoldersBooksList: "api/categories/",

    systemFoldersMultipleBooksLists: "api/categories/subjects/filter",
    filter: "api/categories/filter",
    updateBook: "api/books/updates/last",
    updateWord: "api/words/updates/last",
    updateFSWord: "api/words/fs/updates/last",
    bookImages: "api/images",
    byPos: "/byPos",
    freeSearch: "api/freesearch",
    words: "/words",
    gzirim: "/gzirim",
    coords: "/coords",
    license: "api/license",
    noPrintBooks: "api/general/noPrintBooks",
    systemFonts: "api/general/fonts",
    createPdf: "api/general/createPdf",
  },
  UsersDB: {
    changePassword: "/changePassword",
    forgotPassword: "/forgotPassword",
    reset: "/reset",
    userBookDetails: "api/user/bookdetails",
    userReset: "api/user/factory-reset",
    recentBooks: "/recentbooks",
    favorites: "/favorites",
    /**@type {string} url - /api/user  */
    users: "api/user",
    settings: "/settings",
    login: "/login",
    logout: "/logout",
    tsiyuns: "/tsiyuns",
    altWords: "/altWords",
    book: "/book",
    userLists: "api/userlists",
    quickbutton: "/quickbutton",
    desktops: "/desktops",
    freeuser: "/freeuser",
    recent: "/recent",
    history: "api/history",
    historyType: "/type",
    personalComments: "/comments",
    personalKeys: "/maftechot",
    personalLinks: "/links",
    personalMarks: "/marks",
    sendEmail: "api/mail",
    customSorts: "api/customsorts",
    IP: "/ipUser",
    subUsers: "/subuser",
    permissions: "/permissions",
    /**@type {string} url - /pendingUser  */
    createPendingUser: "/pendingUser",
    /**@type {string} url - /createUserByGuid  */
    createUserByGuid: "/createUserByGuid",
    /**@type {string} url - /connectUser  */
    connectUser: "/connectUser",
    licenseInfo: "/license-info",
    actualizeDay: "/actualize-day",
    /**@type {string} url - /extraInfo  */
    extraInfo: "/extraInfo",
  },
  MefoDB: {
    shas: "api/mefo/shas",
    mefarshim: "api/mefo/mefarshim",
    catSecTitle: "api/mefo/catSection",
  },
  general: {
    openStore: "api/general/openOtzarStore",
    getofflineproducts: "api/general/getofflineproducts",
  },
};

export default data;
